module.exports = __webpack_public_path__ + "img/demo3.522a5e70.png";